<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="tankAbstract"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'District',
		'Tank_App',
		'Tank_Coverage_Area',
		'Tank_Verified_App',
		'Tank_RP_App',
		'tank_Rejected_App',
		'Tank_Verified_Coverage_Area',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'TANK_ABSTRACT_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Tank_App">{{'TANK_APP'| translate}}
                    <p-columnFilter type="text" field="Tank_App" display="menu"></p-columnFilter>
                    <p-sortIcon field="Tank_App"></p-sortIcon>
                </th>
                <th pSortableColumn="Tank_Coverage_Area">{{'TANK_COVERAGE_AREA'| translate}}
                    <p-columnFilter type="text" field="Tank_Coverage_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Tank_Coverage_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="Tank_Verified_App">{{'TANK_VERIFIED_APP'| translate}}
                    <p-columnFilter type="text" field="Tank_Verified_App" display="menu"></p-columnFilter>
                    <p-sortIcon field="Tank_Verified_App"></p-sortIcon>
                </th>
                <th pSortableColumn="Tank_RP_App">{{'TANK_RP_APP'| translate}}
                    <p-columnFilter type="text" field="Tank_RP_App" display="menu"></p-columnFilter>
                    <p-sortIcon field="Tank_RP_App"></p-sortIcon>
                </th>
                <th pSortableColumn="tank_Rejected_App">{{'TANK_REJECTED_APP'| translate}}
                    <p-columnFilter type="text" field="tank_Rejected_App" display="menu"></p-columnFilter>
                    <p-sortIcon field="tank_Rejected_App"></p-sortIcon>
                </th>
                <th pSortableColumn="Tank_Verified_Coverage_Area">{{'TANK_VERIFIED_COVERAGE_AREA'| translate}}
                    <p-columnFilter type="text" field="Tank_Verified_Coverage_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Tank_Verified_Coverage_Area"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tankAbstract>
            <tr>
                <td>{{tankAbstract.District}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(tankAbstract.District,'All')">{{tankAbstract.Tank_App}}</a></td>
                <td>{{tankAbstract.Tank_Coverage_Area}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(tankAbstract.District,'Approved')">{{tankAbstract.Tank_Verified_App}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(tankAbstract.District,'Incomplete')">{{tankAbstract.Tank_RP_App}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(tankAbstract.District,'Rejected')">{{tankAbstract.tank_Rejected_App}}</a></td>
                <td>{{tankAbstract.Tank_Verified_Coverage_Area}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{tankApp | number:'1.0-2'}}</td>
                <td >{{tankCoverageArea | number:'1.0-2'}}</td>
                <td >{{tankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{tankRpApp | number:'1.0-2'}}</td>
                <td >{{tankRejectedApp | number:'1.0-2'}}</td>
                <td >{{tankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandTankApp | number:'1.0-2'}}</td>
                <td >{{grandTankCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{grandTankRpApp | number:'1.0-2'}}</td>
                <td >{{grandTankRejectedApp | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Abstract Report Of All Applications of {{value}} "  [(visible)]="displayMaximizable_all" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_all" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog> 
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Abstract Report Of Verified Applications of {{value}} "  [(visible)]="displayMaximizable_verified" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_verified" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Abstract Report Of RP Applications of {{value}} "  [(visible)]="displayMaximizable_rp" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_rp" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Abstract Report Of Rejected Applications of {{value}} "  [(visible)]="displayMaximizable_rejected" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_rejected" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   